import { ACTION_TYPES, STATUS_TYPES, Story } from '@shared/api/types/story';

export const magicStoreTokenCashback: Story = {
  id: 'magic-store-token-cashback',
  type: 'CLASSIC',
  status: STATUS_TYPES.ACTIVE,
  name: 'Magic Store Token Cashback',
  index: 0,
  content: {
    type: ACTION_TYPES.GO_TO,
    bannerUrl: 'stories/5/main_banner.jpg',
    bannerMobileUrl: 'stories/5/main_banner_mobile.jpg',
    internalRoute: '/store/hot-offers',
    buttonText: 'Go to Hot Offers',
    title: "Magic Square's Groundbreaking Token Cashback",
    description:
      'By introducing "Token CashBack", we at Magic Square reaffirm our dedication to offering exclusive and ground-breaking features to our users. We are the go-to destination for token purchases, providing you with experiences that reshape the Web3 landscape. Stay tuned as we continue to revolutionize your Web3 journey.',
    storyBlocks: [
      {
        bannerUrl: 'stories/5/story_banner_url_1.jpg',
        title: 'Revolutionising the Web3 Ecosystem',
        description:
          "At Magic Square, we're redefining the way you navigate the Web3 world. Serving as your ultimate gateway to Web3 discovery and rewards, our Magic Store Web3 App Store has already welcomed a whopping 150,000 new users within just the last month. We're not just revolutionising how you interact with Web3; we're also presenting fresh, inventive ways for you to earn while exploring this thrilling space.",
      },
      {
        bannerUrl: 'stories/5/story_banner_url_2.jpg',
        title: 'Web3 Hot Deals: Your Groupon of the Digital Realm',
        description:
          "One of our most popular features, the 'Hot Offers' section – often compared to 'Groupon' in the Web3 realm – has indeed become a hit among our users. Each day, we see thousands of repeat users flocking to the Hot Offers section, thrilled to discover the latest promotions and the earnings they can garner from them.",
      },
      {
        bannerUrl: 'stories/5/story_banner_url_3.jpg',
        title: 'Introducing "Token Cashback"',
        description:
          'Today, we\'re excited to introduce a brand-new feature in our "Hot Offers" section: "Token CashBack". For the first time in the Web3 ecosystem, users can now purchase tokens from their favourite Binance projects and instantly receive a cashback reward. This ground-breaking feature, brought to you exclusively by Magic Square in collaboration with Binance, is an industry-first and is set to redefine how you buy your favourite tokens.',
      },
      {
        bannerUrl: 'stories/5/story_banner_url_4.jpg',
        title: 'How Does it Work?',
        description:
          "In the $1INCH token cashback offer, you're required to stake a total of $500 or more on the 1inch Network, either in one transaction or across multiple transactions. Upon completing this, you'll receive a $35 commission. The tokens you staked will be locked up for a certain period before they can be redeemed or transacted with. Notably, this is a straightforward staking and earning offer, giving you an immediate return on your staked tokens.",
      },
      {
        bannerUrl: 'stories/5/story_banner_url_5.jpg',
        title: 'The First Token CashBack Campaign',
        description:
          "We're thrilled to introduce our campaign featuring $1INCH. Users have the opportunity to stake $500 worth of $1INCH tokens and in return receive a generous 7% CashBack reward, which equates to a $35 cashback.\n\nTo participate in this fantastic deal, you'll need to create a Magic Store account, verify it, and accrue a minimum of 50 Karma points, which is the entry threshold for this campaign. Get ready to seize this exclusive opportunity!",
      },
    ],
  },
};
